jQuery(document).ready(function($){
    function wm_float_format(value, precision) {
        return value.toFixed(precision);
    }

    function wm_get_price_mode() {
        return $('input[name="price_type"]:checked').val();
    }

    $('#promo-checkbox').change(function() {
        let promo_on = $(this).prop('checked');
        let price_mode = wm_get_price_mode();

        $('[data-price-primary]').each(function() {
            let price = $(this).data('price');

            if (price === undefined) {
                return;
            }

            price = parseFloat(price);

            if (price === NaN) {
                return;
            }

            // if (!promo_on) {
            //     price = price * 1.1;
            // }

            if (price_mode == 'brutto') {
                price = price * 1.23;
            }

            price = wm_float_format(price, 2);
            $(this).text(`${price}`);
        });
    });

    $('input[name="price_type"]').change(function() {
        let price_mode = $(this).val();

        $('[data-price]').each(function() {
            let price = $(this).data('price');
            let promo_on = true;

            if ($(this).data('price-primary') !== undefined) {
                promo_on = $('#promo-checkbox').prop('checked');
            }

            if (price === undefined) {
                return;
            }

            price = parseFloat(price);

            if (price === NaN) {
                return;
            }

            // if (!promo_on) {
            //     price = price * 1.1;
            // }

            if (price_mode == 'brutto') {
                price = price * 1.23;
            }

            price = wm_float_format(price, 2);
            $(this).text(`${price}`);
        });
    });
});
